import type { SVGProps } from 'react';

const SvgTranslucent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 7h-1V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h1v1c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-8c0-1.65-1.35-3-3-3M6 15c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v1h-5c-1.65 0-3 1.35-3 3v5zm3-2.09L11.09 15H9zM13.91 15 9 10.09V10c0-.55.45-1 1-1h.09L15 13.91V14c0 .55-.45 1-1 1zM15 11.09 12.91 9H15zM19 18c0 .55-.45 1-1 1h-8c-.55 0-1-.45-1-1v-1h5c1.65 0 3-1.35 3-3V9h1c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgTranslucent;
